import { withRouter } from 'hooks/withRouter';
import React from 'react';
import CampaignDetails from './components/Campaigns';
import CreditDetails from './components/Credit';
import GamesParent from '../Games';

export default withRouter(function PromoCardDetails({ router: { params: { name } } }) {

  const switchView = () => {
    switch (name) {
      case 'campaign':
        return <CampaignDetails />;
        
      case 'games':
        return <GamesParent />;

      case 'credit':
        return <CreditDetails />;

      default:
        return <></>;
    }
  }

  return (
    <>
      {
        switchView()
      }

      {/* <SuccessNotification /> */}
    </>
  )
})
